import { Select } from 'antd'

export const FilterableSelect = props => (
	<Select {...props} showSearch filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())} />
)
